import { Box, MenuItem, Select, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { CompareSource } from 'modules/common/product-details-page/constants';
import { userService } from 'common/services/user.service';
import { RetailerType } from 'common/constants/entities';
import { getBTNsStyles } from './styles';

interface Props {
  value: CompareSource;
  handleChange: (value: CompareSource) => void;
}

export function SEOCompareSourceToggles({ value, handleChange }: Props): ReactElement {
  const styles = getBTNsStyles();

  const compareSourceOptions = [
    {
      label: 'ORIGINAL',
      value: CompareSource.Original,
    },
    {
      label: 'SEO OPTIMIZED',
      value: CompareSource.SEO,
    },
    ...(userService.ensureRetailer(RetailerType.Target)
      ? [
          {
            label: 'GEO OPTIMIZED',
            value: CompareSource.GEO,
          },
        ]
      : []),
  ];

  return (
    <Box sx={styles.wrapper}>
      <Typography sx={styles.toggle}>SOURCE</Typography>
      <Select
        value={value}
        size="small"
        onChange={e => handleChange(e.target.value as CompareSource)}
        sx={{ minWidth: 200, mx: 2 }}
      >
        {compareSourceOptions.map(o => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
